import { useState, useEffect } from "react";
import Loader from "../BaseFile/comman/Loader";
import { CheckIcon } from "@heroicons/react/20/solid";
import Spinner from "../BaseFile/comman/Spinner";
import UserPlanConfirmation from "./UserPlanConfirmation";
import SuccessAlert from "../BaseFile/comman/SuccessAlert";
import ErrorAlert from "../BaseFile/comman/ErrorAlert";
import UserEntryFeeConfirmation from "./UserEntryFeeConfirmation";
import { getAllPlans } from "../redux/planSlice";
import { getUser } from "../redux/userSlice";
import { clearErrors, clearMessage } from "../redux/depositeSlice";
import { useDispatch, useSelector } from "react-redux";
import { Check, X } from "lucide-react";
export default function UserPlan() {
  const dispatch = useDispatch();
  const { allplans, loading } = useSelector((state) => state.allplans);
  const {
    error,
    message,
    loading: topUpLoading,
  } = useSelector((state) => state.alltopup);
  const { auth } = useSelector((state) => state.auth);
  const { singleuser } = useSelector((state) => state.allusers);

  const [planConfirm, setPlanConfirm] = useState(false);
  const [plan, setPlan] = useState();
  const [entryPlanModel, setEntryPlanModel] = useState(false);

  useEffect(() => {
    dispatch(getAllPlans());
    if (auth?.id) {
      const id = auth?.id;
      dispatch(getUser(id));
    }
    if (error) {
      const errorInterval = setInterval(() => {
        dispatch(clearErrors());
      }, 3000);
      return () => clearInterval(errorInterval);
    }
    if (message) {
      const messageInterval = setInterval(() => {
        dispatch(clearMessage());
      }, 3000);
      return () => clearInterval(messageInterval);
    }
  }, [dispatch, error, message, clearErrors, clearMessage]);

  function handleBuyPlan(plan) {
    setPlan(plan);
    setPlanConfirm(true);
  }
  function isclose() {
    setPlan(null);
    setPlanConfirm(false);
    setEntryPlanModel(false);
  }

  function handleEntryPlan() {
    setEntryPlanModel(true);
  }

  const getPlanImg = (planName) => {
    switch (planName.toLowerCase().trim()) {
      case "bronze":
        return "https://img.freepik.com/free-vector/ai-powered-marketing-tools-abstract-concept-illustration_335657-3796.jpg?uid=R176823449&ga=GA1.1.1433286368.1718702777&semt=ais_hybrid&w=740";
      case "silver":
        return "https://img.freepik.com/free-vector/call-center-isometric-concept_1284-69078.jpg?uid=R176823449&ga=GA1.1.1433286368.1718702777&semt=ais_hybrid&w=740";
      case "golden":
        return "https://img.freepik.com/free-vector/ai-powered-marketing-tools-ai-powered-research-marketing-tools-automation-e-commerce-search-customer-recommendation-machine-learning_335657-4497.jpg?uid=R176823449&ga=GA1.1.1433286368.1718702777&semt=ais_hybrid&w=740";
      case "entry bot":
        return "https://img.freepik.com/free-vector/hand-drawn-ai-investing-illustration_23-2151180675.jpg?uid=R176823449&ga=GA1.1.1433286368.1718702777&semt=ais_hybrid&w=740";
      case "platinum":
        return "https://img.freepik.com/free-psd/futuristic-robot-illustration_23-2150978988.jpg?uid=R176823449&ga=GA1.1.1433286368.1718702777&semt=ais_hybrid&w=740";
      case "diamond":
        return "https://img.freepik.com/free-vector/chatbot-development-platform-abstract-concept-illustration_335657-3721.jpg?uid=R176823449&ga=GA1.1.1433286368.1718702777&semt=ais_hybrid&w=740";
      default:
        return "https://img.freepik.com/free-vector/artificial-intelligence-ai-calculating-taxation-multiplier-value-added-tax-system-vat-number-validation-global-taxation-control-concept-pinkish-coral-bluevector-isolated-illustration_335657-1796.jpg?uid=R176823449&ga=GA1.1.1433286368.1718702777&semt=ais_hybrid&w=740";
    }
  };

  const getPlanGradient = (planName) => {
    switch (planName.toLowerCase()) {
      case "bronze":
        return "bg-gradient-to-br from-amber-200 to-amber-400";
      case "silver":
        return "bg-gradient-to-br from-gray-100 to-gray-300";
      case "golden":
        return "bg-gradient-to-br from-yellow-100 to-yellow-300";
      case "entry bot":
        return "bg-gradient-to-br from-blue-100 to-blue-300";
      case "platinum":
        return "bg-gradient-to-br from-indigo-100 to-indigo-300";
      case "diamond":
        return "bg-gradient-to-br from-cyan-100 to-cyan-300";
      default:
        return "bg-gradient-to-br from-gray-100 to-gray-300";
    }
  };

  const getTextColor = (planName) => {
    switch (planName.toLowerCase()) {
      case "bronze":
        return "text-amber-800";
      case "silver":
        return "text-gray-700";
      case "golden":
        return "text-yellow-700";
      case "entry bot":
        return "text-blue-700";
      case "platinum":
        return "text-indigo-700";
      case "diamond":
        return "text-cyan-700";
      default:
        return "text-gray-700";
    }
  };

  const getButtonGradient = (planName) => {
    switch (planName.toLowerCase()) {
      case "bronze":
        return "bg-gradient-to-r from-amber-500 to-amber-700 hover:from-amber-600 hover:to-amber-800";
      case "silver":
        return "bg-gradient-to-r from-gray-400 to-gray-600 hover:from-gray-500 hover:to-gray-700";
      case "golden":
        return "bg-gradient-to-r from-yellow-500 to-yellow-700 hover:from-yellow-600 hover:to-yellow-800";
      case "entry bot":
        return "bg-gradient-to-r from-blue-400 to-blue-600 hover:from-blue-500 hover:to-blue-700";
      case "platinum":
        return "bg-gradient-to-r from-indigo-400 to-indigo-600 hover:from-indigo-500 hover:to-indigo-700";
      case "diamond":
        return "bg-gradient-to-r from-cyan-400 to-cyan-600 hover:from-cyan-500 hover:to-cyan-700";
      default:
        return "bg-gradient-to-r from-gray-400 to-gray-600 hover:from-gray-500 hover:to-gray-700";
    }
  };

  // const compoundPlan = allplans?.find((item) => item.name === "Compound Plan");

  return (
    <>
      {message && <SuccessAlert message={message} />}
      {error && <ErrorAlert error={error} />}

      {loading ? (
        <Loader isLoading={loading} />
      ) : (
        <div className="bg-gray-50 min-h-screen py-12 px-4">
          <div className="max-w-6xl mx-auto">
            <h1 className="text-4xl font-bold text-center mb-4 text-gray-800">
              Investment Plans
            </h1>
            <p className="text-center text-gray-600 mb-12 max-w-2xl mx-auto">
              Choose the perfect investment plan to maximize your returns and
              achieve your financial goals.
            </p>

            {/* <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {singleuser?.entry_fees == 0 ?
               allplans
                    ?.filter((item) => item.name == "entry bot")
                    .map((plan) => (
                      <div
                        key={plan.id}
                        className="rounded-2xl text-gray-700 overflow-hidden shadow-md transform transition duration-300 hover:scale-105 hover:shadow-xl bg-white"
                      >
                        <div className={`${getPlanGradient(plan.name)} p-6`}>
                          <div className="flex justify-between items-start">
                            <h2
                              className={`text-2xl font-bold capitalize tracking-wider mb-2 ${getTextColor(
                                plan.name
                              )}`}
                            >
                              {plan.name}
                            </h2>
                            <div className="bg-white bg-opacity-30 rounded-full p-2">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                className="h-6 w-6"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth={2}
                                  d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                                />
                              </svg>
                            </div>
                          </div>
                          <div className="flex items-end mt-2">
                            <span
                              className={`text-4xl font-bold ${getTextColor(
                                plan.name
                              )}`}
                            >
                              ${plan.monthly_price}
                            </span>
                            {plan.id !== 4 && (
                              <span
                                className={`ml-1 text-sm opacity-80 ${getTextColor(
                                  plan.name
                                )}`}
                              >
                                min investment
                              </span>
                            )}
                          </div>
                          <p
                            className={`mt-2 text-sm ${getTextColor(
                              plan.name
                            )} opacity-90`}
                          >
                            {plan.description || "Premium investment plan"}
                          </p>
                        </div>

                        <div className="p-6">
                          <ul className="space-y-3">
                           
                            <li className="flex justify-between items-center">
                              <span className="text-gray-600">Monthly ROI</span>
                              <span className="font-semibold text-gray-800 px-3 py-1 rounded-full">
                                {plan.ROI_overall}%
                              </span>
                            </li>
                            <li className="flex justify-between items-center">
                              <span className="text-gray-600">Bonus</span>
                              <span className="font-semibold text-gray-800 px-3 py-1 rounded-full">
                                {plan.bonus}%
                              </span>
                            </li>
                     
                            <li className="flex justify-between items-center">
                              <span className="text-gray-600">Plan Period</span>
                              <span className="font-semibold text-gray-800 px-3 py-1 rounded-full">
                                {plan.plan_period} months
                              </span>
                            </li>
                     
                         
                            {plan.id !== 4 && (
                              <li className="flex justify-between items-center">
                                <span className="text-gray-600">
                                  Investment Range
                                </span>
                                <span className="font-semibold text-gray-800 px-3 py-1 rounded-full">
                                  ${plan.min} - ${plan.max.toLocaleString()}
                                </span>
                              </li>
                            )}
                          </ul>
                          <button
                            onClick={() => handleEntryPlan()}
                            className={`w-full mt-6 py-3 px-4 rounded-lg text-white font-bold transition-colors ${getButtonGradient(
                              plan.name
                            )}`}
                          >
                            {loading ? <Spinner /> : "Buy Plan "}
                          </button>
                          <div className="mt-4 pt-4 border-t border-gray-100">
                            <p className="text-xs text-gray-500">
                              <span className="font-medium">T&C:</span>{" "}
                              Participants must be at least 18 years old to
                              enroll in any marketing plan.
                            </p>
                          </div>
                        </div>
                      </div>
                    ))
                : allplans
                    ?.filter(
                      (item) =>
                        item.name !== "entry bot" &&
                        item.name !== "Compound Plan"
                    )
                    .map((plan) => (
                      <div
                        key={plan.id}
                        className="rounded-2xl text-gray-700  overflow-hidden shadow-md transform transition duration-300 hover:scale-105 hover:shadow-xl bg-white"
                      >
                        <div className={`${getPlanGradient(plan.name)} p-6`}>
                          <div className="flex justify-between items-start">
                            <h2
                              className={`text-2xl font-bold capitalize tracking-wider mb-2 ${getTextColor(
                                plan.name
                              )}`}
                            >
                              {plan.name}
                            </h2>
                            <div className="bg-white bg-opacity-30 rounded-full p-2">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                className="h-6 w-6"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth={2}
                                  d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                                />
                              </svg>
                            </div>
                          </div>
                          <div className="flex items-end mt-2">
                            <span
                              className={`text-4xl font-bold ${getTextColor(
                                plan.name
                              )}`}
                            >
                              ${plan.monthly_price}
                            </span>
                            {plan.id !== 4 && (
                              <span
                                className={`ml-1 text-sm opacity-80 ${getTextColor(
                                  plan.name
                                )}`}
                              >
                                min investment
                              </span>
                            )}
                          </div>
                          <p
                            className={`mt-2 text-sm ${getTextColor(
                              plan.name
                            )} opacity-90`}
                          >
                            {plan.description || "Premium investment plan"}
                          </p>
                        </div>
                        <div className="p-6">
                          <ul className="space-y-3">
                            <li className="flex justify-between items-center">
                              <span className="text-gray-600">Daily ROI</span>
                              <span className="font-semibold text-gray-800 px-3 py-1 rounded-full">
                                {plan.ROI_overall}%
                              </span>
                            </li>
                            <li className="flex justify-between items-center">
                              <span className="text-gray-600">
                                Sponsor Bonus
                              </span>
                              <span className="font-semibold text-gray-800 px-3 py-1 rounded-full">
                                {plan.Sponser_bonus}%
                              </span>
                            </li>
                            {plan.id !== 4 && (
                              <li className="flex justify-between items-center">
                                <span className="text-gray-600">
                                  Investment Range
                                </span>
                                <span className="font-semibold bg-gray-100 px-3 py-1 rounded-full">
                                  ${plan.min} - ${plan.max.toLocaleString()}
                                </span>
                              </li>
                            )}
                          </ul>
                          <button
                            onClick={() => handleBuyPlan(plan)}
                            className={`w-full mt-6 py-3 px-4 rounded-lg text-white font-bold transition-colors ${getButtonGradient(
                              plan.name
                            )}`}
                          >
                            {loading ? <Spinner /> : "Buy Plan "}
                          </button>
                          <div className="mt-4 pt-4 border-t border-gray-100">
                            <p className="text-xs text-gray-500">
                              <span className="font-medium">T&C:</span>{" "}
                              Participants must be at least 18 years old to
                              enroll in any marketing plan.
                            </p>
                          </div>
                        </div>
                      </div>
                    ))}
            </div> */}

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 ">
              {singleuser?.entry_fees == 0
                ? allplans
                    ?.filter((item) => item.name === "entry bot")
                    .map((plan) => (
                      <div
                        key={plan.id}
                        className="w-full mt-20 bg-white shadow-lg rounded-xl relative"
                      >
                        {/* Colored side bar */}
                        <div
                          className={`absolute left-0 top-0 bottom-0 w-1 ${
                            plan.color === "green"
                              ? "bg-green-500"
                              : plan.color === "blue"
                              ? "bg-blue-600"
                              : "bg-pink-500"
                          }`}
                        />

                        {/* Price Circle */}
                        <div
                          className={`absolute left-6 -top-6 transform -translate-y-1/2 `}
                        >
                          <div className="flex items-center justify-center  text-white rounded-full w-24 h-24">
                            <div className="text-center">
                              <div
                                className={`text-2xl font-bold ${getTextColor(
                                  plan.name
                                )}`}
                              >
                                ${plan.monthly_price}
                              </div>
                              {plan.id !== 4 && (
                                <span
                                  className={`text-sm opacity-80 ${getTextColor(
                                    plan.name
                                  )}`}
                                >
                                  min invest.
                                </span>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="absolute right-0 transform">
                          <div className="flex items-center justify-center text-white rounded-full w-28 h-28">
                            <div className="text-center">
                              <img
                                className="w-48"
                                src={getPlanImg(plan.name)}
                                alt="Plan"
                              />
                            </div>
                          </div>
                        </div>

                        {/* Plan Details */}
                        <div className="pt-16 px-6 pb-6">
                          {/* Plan Name */}
                          <h3
                            className={`text-xl font-medium mb-6 ${
                              plan.color === "green"
                                ? "text-green-500"
                                : plan.color === "blue"
                                ? "text-blue-600"
                                : "text-pink-500"
                            }`}
                          >
                            {plan.name}
                          </h3>

                          {/* Features */}
                          <ul className="space-y-3">
                            <li className="flex justify-between items-center">
                              <span className="text-gray-600">Monthly ROI</span>
                              <span className="font-semibold bg-gray-100 px-3 py-1 rounded-full">
                                {plan.ROI_overall}%
                              </span>
                            </li>
                            <li className="flex justify-between items-center">
                              <span className="text-gray-600">Bonus</span>
                              <span className="font-semibold bg-gray-100 px-3 py-1 rounded-full">
                                {plan.bonus}%
                              </span>
                            </li>
                            <li className="flex justify-between items-center">
                              <span className="text-gray-600">Plan Period</span>
                              <span className="font-semibold bg-gray-100 px-3 py-1 rounded-full">
                                {plan.plan_period} months
                              </span>
                            </li>
                            {plan.id !== 4 && (
                              <li className="flex justify-between items-center">
                                <span className="text-gray-600">
                                  Investment Range
                                </span>
                                <span className="font-semibold bg-gray-100 px-3 py-1 rounded-full">
                                  ${plan.min} - ${plan.max.toLocaleString()}
                                </span>
                              </li>
                            )}
                          </ul>

                          {/* Call to Action */}
                          <button
                            onClick={() => handleEntryPlan()}
                            className={`w-full mt-6 py-3 px-4 rounded-lg text-white font-bold transition-colors ${getButtonGradient(
                              plan.name
                            )}`}
                          >
                            {loading ? <Spinner /> : "Buy Plan"}
                          </button>

                          {/* Terms */}
                          <div className="mt-4 pt-4 border-t border-gray-100">
                            <p className="text-xs text-gray-500">
                              <span className="font-medium">T&C:</span>{" "}
                              Participants must be at least 18 years old to
                              enroll in any marketing plan.
                            </p>
                          </div>
                        </div>

                        {/* Bottom Bar */}
                        <div className="bg-gray-800 text-white text-center py-3 uppercase text-sm font-medium tracking-wider">
                          Select Package
                        </div>
                      </div>
                    ))
                : allplans
                    ?.filter(
                      (item) =>
                        item.name !== "entry bot" &&
                        item.name !== "Compound Plan"
                    )
                    .map((plan) => (
                      <div
                        key={plan.id}
                        className="w-full mt-16 bg-white shadow-sm rounded-md border-l-0 border-t border-b border-r border-gray-300 relative"
                      >
                        {/* Colored side bar */}
                        <div
                          className={`absolute left-0 ${getPlanGradient(
                            plan.name
                          )} top-0 bottom-0 w-2 ${
                            plan.color === "green"
                              ? "bg-green-600"
                              : plan.color === "blue"
                              ? "bg-blue-600"
                              : "bg-pink-600"
                          }`}
                        />

                        {/* Price Circle */}
                        <div
                          className={`absolute left-0 -top-0 transform -translate-y-1/2 `}
                        >
                          <div
                            className={` flex items-center justify-center ${getPlanGradient(
                              plan.name
                            )} text-white rounded-full w-28 h-28  `}
                          >
                            <div className="text-center">
                              <div
                                className={`text-xl font-semibold ${getTextColor(
                                  plan.name
                                )}`}
                              >
                                ${plan.monthly_price}
                              </div>
                              {plan.id !== 4 && (
                                <span
                                  className={`text-sm opacity-80 ${getTextColor(
                                    plan.name
                                  )}`}
                                >
                                  min invest.
                                </span>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="absolute right-0 transform">
                          <div className="flex items-center justify-center text-white rounded-full w-28 h-28">
                            <div className="text-center">
                              <img
                                className="w-48"
                                src={getPlanImg(plan.name)}
                                alt="Plan"
                              />
                            </div>
                          </div>
                        </div>

                        {/* Plan Details */}
                        <div className="pt-16 px-6 pb-6">
                          {/* Plan Name */}
                          <h3
                            className={`text-xl font-medium mb-6 ${
                              plan.color === "green"
                                ? "text-green-500"
                                : plan.color === "blue"
                                ? "text-blue-600"
                                : "text-pink-500"
                            }`}
                          >
                            {plan.name}
                          </h3>

                          {/* Features */}
                          <ul className="space-y-3">
                            <li className="flex justify-between items-center">
                              <span className="text-gray-600">Daily ROI</span>
                              <span className="font-semibold text-gray-700 px-3 py-1 rounded-full">
                                {plan.ROI_overall}%
                              </span>
                            </li>
                            {/* <li className="flex justify-between items-center">
                              <span className="text-gray-600">Bonus</span>
                              <span className="font-semibold text-gray-800 px-3 py-1 rounded-full">
                                {plan.bonus}%
                              </span>
                            </li> */}
                            <li className="flex justify-between items-center">
                              <span className="text-gray-600">Plan Period</span>
                              <span className="font-semibold text-gray-800 px-3 py-1 rounded-full">
                                {plan.plan_period} months
                              </span>
                            </li>
                            {plan.id !== 4 && (
                              <li className="flex justify-between items-center">
                                <span className="text-gray-600">
                                  Invest. Range
                                </span>
                                <span className="font-semibold text-gray-800 text-sm px-3 py-1 rounded-full">
                                  ${plan.min} - ${plan.max.toLocaleString()}
                                </span>
                              </li>
                            )}
                          </ul>

                          {/* Call to Action */}
                          <button
                            onClick={() => handleBuyPlan(plan)}
                            className={`w-full mt-6 py-3 px-4 rounded-lg text-white font-bold transition-colors ${getButtonGradient(
                              plan.name
                            )}`}
                          >
                            {loading ? <Spinner /> : "Buy Plan"}
                          </button>

                          {/* Terms */}
                          <div className="mt-4 pt-4 border-t border-gray-100">
                            <p className="text-xs text-gray-500">
                              <span className="font-medium">T&C:</span>{" "}
                              Participants must be at least 18 years old to
                              enroll in any marketing plan.
                            </p>
                          </div>
                        </div>

                        {/* Bottom Bar */}
                        <div className="bg-gray-800 text-white text-center py-3 uppercase text-sm font-medium tracking-wider">
                          Select Package
                        </div>
                      </div>
                    ))}
            </div>
          </div>
        </div>
      )}

      {planConfirm && (
        <UserPlanConfirmation
          isclose={isclose}
          plan={plan}
          user_id={auth?.id}
        />
      )}
      {entryPlanModel && (
        <UserEntryFeeConfirmation isclose={isclose} user_id={auth?.id} />
      )}
    </>
  );
}
